module.exports = __webpack_public_path__ + "static/media/77156710-6a58-4606-b189-b4185e75967b-ext.5b015023.woff2";